// removed by extract-text-webpack-plugin
module.exports = {"main":"#1A2C5A","large_desktop":"only screen and (min-width: 1201px)","desktop":"only screen and (min-width: 1025px) and (max-width: 1200px)","tablet":"only screen and (min-width: 768px) and (max-width: 1024px)","mobile":"only screen and (max-width: 767px)","ourBusines":"ourBusines__2PdJg"};


//////////////////
// WEBPACK FOOTER
// ./components/OurBusiness/style.css
// module id = jaMC
// module chunks = 0